declare namespace $ {

	export class $mol_view_tree2_to_js_test_ex_simple_nan_foo extends $mol_object {
		a( ): number
		b( ): number
		c( ): number
		d( ): number
		e( ): number
		f( ): number
	}
	
}

//# sourceMappingURL=simple_nan.view.tree.d.ts.map